import { IItemPublicoAlvo } from './item-publico-alvo.interface';

export interface IPLM {
  nucleoPLM: number;
  fasePLM: number;
  cicloPLM: number;
  tipoEstrategicoPLM: number;
  dataPesquisaPLM: Date;
  dataDesenvolvimentoPLM: Date;
  dataGoToMarketPLM: Date;
  dataNascimentoPLM: Date;
  dataEncerramentoPLM: Date;
  idClassificacaoPLMRAP?: number;
  idClassificacaoPLMRAR?: number;
  idDNAPLM?: number;
  taxaAdocaoPLM?: number;
  pesoMedioMaturacaoPLM?: number;
  taxaMaturacaoNascimentoPLM?: number;
  taxaMaturacaoCrescimentoPLM?: number;
  taxaMaturacaoFortalecimentoPLM?: number;
  taxaMaturacaoMaturidadePLM?: number;
  publicosAlvo?: IItemPublicoAlvo[];
}

/** Campos do PLM tratados como percentual (input pt-BR ↔ número). */
export const PERCENT_PLM_FIELDS = [
  'taxaAdocaoPLM',
  'taxaMaturacaoNascimentoPLM',
  'taxaMaturacaoCrescimentoPLM',
  'taxaMaturacaoFortalecimentoPLM',
  'taxaMaturacaoMaturidadePLM',
] as const;

export const DATE_PLM_FIELDS = [
  'dataPesquisaPLM',
  'dataDesenvolvimentoPLM',
  'dataGoToMarketPLM',
  'dataNascimentoPLM',
  'dataEncerramentoPLM',
] as const;

/** Campos do PLM governados pela permissão `podeEditarDadosPLM`. */
export const CAMPOS_PLM_EDITAVEIS = [
  'tipoEstrategicoPLM',
  'idClassificacaoPLMRAP',
  'dataPesquisaPLM',
  'dataDesenvolvimentoPLM',
  'dataGoToMarketPLM',
  'dataNascimentoPLM',
  'publicosAlvo',
  'idDNAPLM',
  'taxaAdocaoPLM',
  'pesoMedioMaturacaoPLM',
  'taxaMaturacaoNascimentoPLM',
  'taxaMaturacaoCrescimentoPLM',
  'taxaMaturacaoFortalecimentoPLM',
  'taxaMaturacaoMaturidadePLM',
] as const;
